<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none bg-white" :to="getDefautlPage()">
      <div class="img-logo">
        <img src="@/assets/fabbi_logo.jpeg" class="c-avatar-img" />
      </div>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="nav" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="
        $store.dispatch('layout/setSidebar', ['sidebarMinimize', !minimize])
      "
    />
  </CSidebar>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import urlPermissionMap from "@/config/urlPermissionMap.json";

export default {
  name: "Sidebar",
  created() {
    this.loadSidebar();
  },
  computed: {
    ...mapState("layout", {
      show: (state) => state.sidebarShow,
      minimize: (state) => state.sidebarMinimize,
    }),
    ...mapState("auth", {
      account: (state) => state.account,
    }),
     ...mapGetters({
      account: "auth/account"
    }),
  },
  watch: {
    account: function () {
      this.loadSidebar();
    },
  },

  methods: {
    ...mapActions("layout", ["setSidebar"]),
    handleCollapseSidebar() {
      this.$store.dispatch("layout/toggleSidebarDesktop");
    },
    getDefautlPage() {
      let routerDashbord = urlPermissionMap["dashboard"];
      const userPermission = this.account.permissions || [];
      if(userPermission.includes(routerDashbord)) {
        return { name: "dashboard"}
      }
      return { name: "AdminDefault"};
    },
    loadSidebar() {
      let dataPermissionCanAccess =
        this.account.permissions !== undefined ? this.account.permissions : [];
      let sidebar = [
        {
          _name: "CSidebarNavItem",
          name: "Dashboard",
          to: "/dashboard",
          icon: "cil-bar-chart",
          permission: "dashboard",
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.employee.label_title"),
          to: "/employees",
          icon: "cil-people",
          items: [
            {
              name: this.$t("sidebar.employee.label_list"),
              to: "/employees",
              permission: "employees",
            },
            {
              name: this.$t("sidebar.employee.label_list_resignation"),
              to: "/employees/resignation",
              permission: "employees.resignation",
            },
            {
              name: this.$t("sidebar.employee.label_create"),
              to: "/employees/create",
              permission: "employees.create",
            },
            {
              name: this.$t("employee_level.label_employee_level"),
              to: "/employee-level",
              permission: "employee-level.list",
            },
            {
              name: this.$t("sidebar.seating_chart.label_list"),
              to: "/seating-chart",
              permission: "skillsheet.list",
            },
            {
              name: this.$t("sidebar.type_work.label_list"),
              to: "/type-work",
              permission: "skillsheet.list",
            },
            {
              name: this.$t("sidebar.travel.label_summer_trip"),
              to: "/summer-trip",
              permission: "accounts",
            },
            {
              name: this.$t("sidebar.travel.label_summer_trip_data_master"),
              to: "/summer-trip-data-master",
              permission: "accounts",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.customer.label_title"),
          to: "/customers",
          icon: "cil-address-book",
          items: [
            {
              name: this.$t("sidebar.customer.label_list"),
              to: "/customers",
              permission: "customers",
            },
            {
              name: this.$t("sidebar.customer.label_create"),
              to: "/customers/create",
              permission: "customers.create",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.project.label_title"),
          to: "/projects",
          icon: "cil-file",
          items: [
            {
              name: this.$t("sidebar.project.label_list"),
              to: "/project-overview",
              permission: "projects",
            },
            {
              name: this.$t("sidebar.project.label_resource_situation"),
              to: "/projects/resource-situation",
              permission: "projects.resource-situation",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.timesheet.label_title"),
          to: "/timesheets",
          icon: "cil-clock",
          items: [
            {
              name: this.$t("sidebar.timesheet.label_list"),
              to: "/timesheets",
              permission: "time-sheets",
            },
            {
              name: this.$t("sidebar.timesheet.label_list_old"),
              to: "/timesheets/old",
              permission: "time-sheets",
            },
            {
              name: this.$t("sidebar.timesheet.label_summary"),
              to: "/timesheets/list-submit",
              permission: "time-sheets",
            },
            {
              name: this.$t("sidebar.timesheet.list_submit_timesheet"),
              to: "/timesheets/summary",
              permission: "time-sheets.summary",
            },
            {
              name: this.$t("sidebar.timesheet.label_remind"),
              to: "/timesheets/remind-history",
              permission: "time-sheets.summary",
            },
            {
              name: this.$t("sidebar.sabbatical_compensate.label_list"),
              to: "/sabbatical-compensate",
              permission: "time-sheets",
            },
            {
              name: this.$t("sidebar.short_leave_request.label_list"),
              to: "/short-leave-requests",
              permission: "short-leave-requests"
            },
            {
              name: this.$t("holiday_setting.title"),
              to: "/holiday-settings",
              permission: "holiday-settings.list"
            },
            {
              name: this.$t("timesheet_submit_period.title"),
              to: "/timesheet-submit-period",
              permission: "timesheet-submit-period.show"
            }
          ]
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.overtime.label_title"),
          to: "/overtime-requests",
          icon: "cil-alarm",
          items: [
            {
              name: this.$t("sidebar.overtime.label_list"),
              to: "/overtime-requests",
              permission: "overtime-requests",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.remote.label_title"),
          to: "/remote-requests",
          icon: "cil-alarm",
          items: [
            {
              name: this.$t("sidebar.remote.label_list"),
              to: "/remote-requests",
              permission: "remote-requests",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.sabbatical-leave-requests.label_title"),
          to: "/sabbatical-leave-requests",
          icon: "cil-description",
          items: [
            {
              name: this.$t("sidebar.sabbatical-leave-requests.label_list"),
              to: "/sabbatical-leave-requests",
              permission: "sabbatical-leave-requests",
            },
            {
              name: this.$t("sabbatical_adjustment.title"),
              to: "/sabbatical-adjustments",
              permission: "sabbatical-adjustments.list",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.account.label_title"),
          to: "/accounts",
          icon: "cil-user",
          items: [
            {
              name: this.$t("sidebar.account.label_list"),
              to: "/accounts",
              permission: "accounts",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.additional_timeSheet.title"),
          to: "/additional-timesheet",
          icon: "cil-note-add",
          items: [
            {
              name: this.$t("sidebar.additional_timeSheet.list"),
              to: "/additional-timesheet",
              permission: "additional-timesheet.list",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.contract.label_title"),
          to: "/contracts",
          icon: "cil-grid",
          items: [
            {
              name: this.$t("sidebar.contract.label_list"),
              to: "/contracts",
              permission: "contracts",
            },
            {
              name: this.$t("sidebar.contract.label_create"),
              to: "/contracts/create",
              permission: "contracts.create",
            },
          ],
        },
        {
          _name: "CSidebarNavDropdown",
          name: this.$t("sidebar.skill_sheet.label_title"),
          to: "/skill",
          icon: "cil-file",
          items: [
            {
              name: this.$t("sidebar.skill_sheet.label_list"),
              to: "/skill",
              permission: "skillsheet.list",
            },
          ],
        },
      ];
      sidebar.forEach((item) => {
        if (item.items) {
          let dataCheck = item.items.filter(function (e) {
            let routerName = urlPermissionMap[e.permission];
            return dataPermissionCanAccess.includes(routerName);
          });

          if (dataCheck.length) {
            item.items = dataCheck;
            this.nav[0]._children.push(item);
          }
        }else {
           let routerName = urlPermissionMap[item.permission];
            if(dataPermissionCanAccess.includes(routerName) && routerName == "dashboard"){
              this.nav[0]._children.unshift(item);
            }
        }
      });
    },
  },
  data: function () {
    return {
      nav: [
        {
          _name: "CSidebarNav",
          _children: [
            {
              _name: "CSidebarNavTitle",
              _children: ["Management"],
            },
          ],
        },
      ],
    };
  },
}
</script>
<style scoped lang="scss">
.img-logo {
  img {
    max-height: 50px;
    width: auto;
  }
}

.c-sidebar-minimized {
  .img-logo {
    display: none;
  }
}

.c-avatar-img {
  width: 100%;
  height: auto;
  border-radius: unset;
}
</style>
